/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Item_Disable_Batching_DescInputs */

const en_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send each tRPC call individually`)
};

const ar_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال كل استدعاء tRPC بشكل منفصل`)
};

const bn_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিটি tRPC কল আলাদাভাবে পাঠান`)
};

const de_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden Sie jeden tRPC-Aufruf einzeln`)
};

const es_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar cada llamada tRPC individualmente`)
};

const fr_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer chaque appel tRPC individuellement`)
};

const pt_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envie cada chamada tRPC individualmente`)
};

const zh_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单独发送每个 tRPC 调用`)
};

const tr_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her tRPC çağrısını ayrı ayrı gönder`)
};

const ru_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправлять каждый вызов tRPC индивидуально`)
};

const pl_dev_item_disable_batching_desc = /** @type {(inputs: Dev_Item_Disable_Batching_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłaj każde wywołanie tRPC indywidualnie`)
};

/**
* | output |
* | --- |
* | "Send each tRPC call individually" |
*
* @param {Dev_Item_Disable_Batching_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_item_disable_batching_desc = /** @type {((inputs?: Dev_Item_Disable_Batching_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Item_Disable_Batching_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_item_disable_batching_desc(inputs)
	if (locale === "bn") return bn_dev_item_disable_batching_desc(inputs)
	if (locale === "de") return de_dev_item_disable_batching_desc(inputs)
	if (locale === "es") return es_dev_item_disable_batching_desc(inputs)
	if (locale === "fr") return fr_dev_item_disable_batching_desc(inputs)
	if (locale === "pt") return pt_dev_item_disable_batching_desc(inputs)
	if (locale === "zh") return zh_dev_item_disable_batching_desc(inputs)
	if (locale === "tr") return tr_dev_item_disable_batching_desc(inputs)
	if (locale === "ru") return ru_dev_item_disable_batching_desc(inputs)
	if (locale === "pl") return pl_dev_item_disable_batching_desc(inputs)
	return en_dev_item_disable_batching_desc(inputs)
});